import { Controller } from "@hotwired/stimulus"

// Edits a column's validation rules (IsNotEmpty / IsMatchRegex). The rules are
// held as DOM rows and serialized into a single hidden `validations_json` field
// so each rule's type and pattern stay paired (Rack would split repeated
// `[][type]`/`[][pattern]` inputs into separate hashes). Any change only
// re-serializes into that hidden field — it persists with the screen's
// explicit save, whose service parses the JSON via Rule.normalize. The
// mutating controls also carry the dirty-guard action.
export default class extends Controller {
  static targets = ["list", "template", "json"]

  add() {
    const row = this.templateTarget.content.firstElementChild.cloneNode(true)
    this.listTarget.appendChild(row)
    this.serialize()
  }

  remove(event) {
    event.currentTarget.closest("[data-rule-row]").remove()
    this.serialize()
  }

  changed() {
    this.serialize()
  }

  serialize() {
    const rules = []
    this.listTarget.querySelectorAll("[data-rule-row]").forEach((row) => {
      const type = row.querySelector("[data-column-validations-target='type']").value
      const pattern = row.querySelector("[data-column-validations-target='pattern']")
      if (type === "is_match_regex") {
        pattern.classList.remove("hidden")
        rules.push({ type, pattern: pattern.value })
      } else {
        pattern.classList.add("hidden")
        rules.push({ type })
      }
    })
    this.jsonTarget.value = JSON.stringify(rules)
  }
}
